import { render, staticRenderFns } from "./MaquinaEstadov1.vue?vue&type=template&id=2aa505d6&"
import script from "./MaquinaEstadov1.vue?vue&type=script&lang=js&"
export * from "./MaquinaEstadov1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports